import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';

export default function Footer() {
  return (
    <>
      <footer className="bg-[#544E13] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center">
                  <i className="ri-fire-line text-2xl text-[#544E13]"></i>
                </div>
                <span className="text-2xl font-bold">RESTAURAX</span>
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                Especialistas en limpieza y restauración post incendio en Hospitalet de Llobregat, Barcelona. Servicio profesional 24/7 con más de 15 años de experiencia.
              </p>
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-map-pin-line text-[#F2D70A]"></i>
                <span className="text-gray-300">Hospitalet de Llobregat, Barcelona</span>
              </div>
              <div className="flex items-center space-x-2 mb-2">
                <i className="ri-phone-line text-[#F2D70A]"></i>
                <a href="tel:690220944" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                  690 22 09 44
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-[#F2D70A]"></i>
                <a href="mailto:info@restaurax.com" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                  info@restaurax.com
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-[#F2D70A]">Enlaces Rápidos</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/empresa" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                    Empresa
                  </Link>
                </li>
                <li>
                  <Link to="/servicios" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                    Servicios
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link to="/contacto" className="text-gray-300 hover:text-[#F2D70A] transition-colors">
                    Contacto
                  </Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-[#F2D70A]">Servicios</h4>
              <ul className="space-y-2 text-gray-300 text-sm">
                <li>Limpieza de hollín</li>
                <li>Eliminación de olores</li>
                <li>Desescombro y vaciado</li>
                <li>Tratamiento de ozono</li>
                <li>Pintura final</li>
                <li>Pequeñas reparaciones</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} RESTAURAX. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/politica-cookies" className="text-gray-400 hover:text-[#F2D70A] transition-colors">
                Política de cookies
              </Link>
              <Link to="/aviso-legal" className="text-gray-400 hover:text-[#F2D70A] transition-colors">
                Aviso legal
              </Link>
              <Link to="/politica-privacidad" className="text-gray-400 hover:text-[#F2D70A] transition-colors">
                Política de privacidad
              </Link>
            </div>
          </div>
        </div>
      </footer>
      <CookieBanner />
    </>
  );
}